
import FormBagsize from '@/components/Form/options/FormBagsize.vue'
import FormBagsizeMobile from '@/components/Form/options/FormBagsizeMobile.vue'
import FormBody from '@/components/Form/options/FormBody.vue'
import FormEdge from '@/components/Form/options/FormEdge.vue'
import FormThread from '@/components/Form/options/FormThread.vue'
import FormInside from '@/components/Form/options/FormInside.vue'
import FormSide from '@/components/Form/options/FromSide.vue'
import FormFront from '@/components/Form/options/FormFront.vue'
import FormPocket from '@/components/Form/options/FormPocket.vue'
import FormTack from '@/components/Form/options/FormTack.vue'
import FormBack from '@/components/Form/options/FormBack.vue'
import FormName from '@/components/Form/options/FormName.vue'
import FormNameMobile from '@/components/Form/options/FormNameMobile.vue'
import GreenboardTab from '@/components/Form/GreenboardTab.vue'
import InitConfigurationService from '@/services/configuration/init-configuration-service'
import { useStore } from '@/store'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import { defineComponent } from 'vue'
import { computed, watch } from 'vue'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'FullorderForm',
  components: {
    FormBagsize,
    FormBagsizeMobile,
    FormBody,
    FormEdge,
    FormThread,
    FormInside,
    FormSide,
    FormFront,
    FormPocket,
    FormTack,
    FormBack,
    FormName,
    FormNameMobile,
    GreenboardTab
  },
  setup() {
    const store = useStore()
    const loadConfig = computed(() => store.getters.loadConfig)

    // prettier-ignore
    watch(() => loadConfig.value, (_) => {
        try {
          const model = new InitConfigurationService().determine()
          store.dispatch(ConfigurationActionTypes.SET_CONFIGURATION, model)
        }
        catch(err) {
          SentrySingleton.instance.captureException(err)
        }
      }
    )

    return {
      loadConfig
    }
  }
})
